import { render, staticRenderFns } from "./VopProviderDetails.vue?vue&type=template&id=6b6c85e5&"
import script from "./VopProviderDetails.vue?vue&type=script&lang=js&"
export * from "./VopProviderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b6c85e5')) {
      api.createRecord('6b6c85e5', component.options)
    } else {
      api.reload('6b6c85e5', component.options)
    }
    module.hot.accept("./VopProviderDetails.vue?vue&type=template&id=6b6c85e5&", function () {
      api.rerender('6b6c85e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vopProvider/VopProviderDetails.vue"
export default component.exports